import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ReservationProvider } from './context/ReservationContext';
import LoadingSpinner from './components/common/LoadingSpinner';
import { NormalReservationProvider } from './normal/context/NormalReservationContext';
import NormalEntry from './normal/pages/NormalEntry';
import NormalFormStep1 from './normal/pages/NormalFormStep1';
import NormalFormStep2 from './normal/pages/NormalFormStep2';
import NormalConfirmation from './normal/pages/NormalConfirmation';
import NormalThanks from './normal/pages/NormalThanks';
import NormalReservationList from './normal/pages/NormalReservationList';

// 遅延ロード用のページコンポーネント
const LandingPage = lazy(() => import('./pages/LandingPage'));
const FormPage1 = lazy(() => import('./pages/FormPage1'));
const FormPage2 = lazy(() => import('./pages/FormPage2'));
const ConfirmationPage = lazy(() => import('./pages/ConfirmationPage'));
const ThanksPage = lazy(() => import('./pages/ThanksPage'));
const ReservationListPage = lazy(() => import('./pages/ReservationListPage'));

// Theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#4caf50',
    },
    secondary: {
      main: '#ff9800',
    },
  },
  typography: {
    fontFamily: [
      '"Hiragino Kaku Gothic ProN"',
      '"Hiragino Sans"',
      'Meiryo',
      '"MS PGothic"',
      'sans-serif',
    ].join(','),
  },
});

const MuiLayout: React.FC = () => (
  <ReservationProvider>
    <Outlet />
  </ReservationProvider>
);

const NormalLayout: React.FC = () => (
  <NormalReservationProvider>
    <Outlet />
  </NormalReservationProvider>
);

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<Navigate to="/lp" replace />} />
          <Route path="/lp" element={<LandingPage />} />

          <Route path="/form/mui" element={<MuiLayout />}>
            <Route index element={<Navigate to="/form/mui/form1" replace />} />
            <Route path="form1" element={<FormPage1 />} />
            <Route path="form2" element={<FormPage2 />} />
            <Route path="confirmation" element={<ConfirmationPage />} />
            <Route path="thanks" element={<ThanksPage />} />
            <Route path="reservations" element={<ReservationListPage />} />
          </Route>

          <Route path="/form/normal" element={<NormalLayout />}>
            <Route index element={<NormalEntry />} />
            <Route path="form1" element={<NormalFormStep1 />} />
            <Route path="form2" element={<NormalFormStep2 />} />
            <Route path="confirmation" element={<NormalConfirmation />} />
            <Route path="thanks" element={<NormalThanks />} />
            <Route path="reservations" element={<NormalReservationList />} />
          </Route>

          <Route path="*" element={<Navigate to="/lp" replace />} />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
};

export default App;
